import { computed, Injectable, OnDestroy, signal } from '@angular/core';
import { SCREEN_BREAKPOINTS } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class BreakpointObserverService implements OnDestroy {
  private resizeSignal = signal(this.getViewportWidth());
  private resizeTimeout: any;

  constructor() {
    this.listenToResize();
  }

  isMobileAgent = signal(this.checkIsMobileAgent());

  isMobile = computed(() => this.resizeSignal() < SCREEN_BREAKPOINTS.tablet);

  isTablet = computed(
    () => this.resizeSignal() >= SCREEN_BREAKPOINTS.tablet && this.resizeSignal() < SCREEN_BREAKPOINTS.desktop,
  );

  isDesktop = computed(() => this.resizeSignal() >= SCREEN_BREAKPOINTS.desktop);

  isDesktopOrBigger = computed(() => this.isDesktop());

  isTabletOrLower = computed(() => this.isMobile() || this.isTablet());

  private checkIsMobileAgent(): boolean {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
  }

  private getViewportWidth(): number {
    return window.innerWidth;
  }

  private onResize = () => {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      this.resizeSignal.set(this.getViewportWidth());
    }, 100); // Adjust debounce time as needed
  };

  private listenToResize(): void {
    window.addEventListener('resize', this.onResize);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.onResize);
  }
}
